const BASE_URL = 'https://back.aifinancehub.net/v1/admin/'
const SOCKET_URL = 'https://api.candlive.com/'

export { BASE_URL, SOCKET_URL }
